import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createSlots as _createSlots, createElementBlock as _createElementBlock, Transition as _Transition, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-grey-lighter h-full flex content-center" }
const _hoisted_2 = {
  key: 0,
  class: "pr-5"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" No results ")

import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: String,
    default: '',
  },
  options: {
    type: Array,
    default: undefined,
  },
  isLoading: Boolean,
},
  emits: ['update:modelValue'],
  setup(__props, { emit: emits }) {

const props = __props





const showSearch = ref(false)
const selectedVal = ref(null)
const selectRef = ref()
const router = useRouter()

watch(() => props.options, () => {
  selectRef.value.refresh()
})

function onOpen () {
  // Set first item as selected
  selectRef.value.setOptionIndex(-1)
  selectRef.value.moveOptionSelection(1, true)
}

function toggleSearch () {
  showSearch.value = !showSearch.value
}

function clearSearch () {
  selectRef.value.updateInputValue('', true, true)
  emits('update:modelValue', '')
}

function filter (val, update) {
  update(
    () => {
      emits('update:modelValue', val)
    },
  )
}

function selectItem () {
  if (selectedVal.value) {
    clearSearch()
    showSearch.value = false
    router.push(selectedVal.value)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_c_tile_btn = _resolveComponent("c-tile-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_c_tile_btn, {
      icon: "inri-search",
      onClick: toggleSearch
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_Transition, { name: "search-transition" }, {
        default: _withCtx(() => [
          (showSearch.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_q_select, _mergeProps({
                  ref_key: "selectRef",
                  ref: selectRef,
                  modelValue: selectedVal.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedVal).value = $event))
                }, _ctx.$inri.inputDense, {
                  class: "w-74",
                  autofocus: "",
                  "use-input": "",
                  "hide-selected": "",
                  "hide-dropdown-icon": "",
                  options: __props.options,
                  loading: __props.isLoading,
                  onFilter: filter,
                  onBlur: clearSearch,
                  onPopupShow: onOpen,
                  "onUpdate:modelValue": selectItem
                }), _createSlots({
                  append: _withCtx(() => [
                    (__props.modelValue.length && !__props.isLoading)
                      ? (_openBlock(), _createBlock(_component_q_icon, {
                          key: 0,
                          name: "mdi-close",
                          color: "grey-darker",
                          class: "cursor-pointer",
                          size: "18px",
                          onClick: _withModifiers(clearSearch, ["stop"])
                        }, null, 8, ["onClick"]))
                      : (!__props.isLoading)
                        ? (_openBlock(), _createBlock(_component_q_icon, {
                            key: 1,
                            name: "inri-search",
                            color: "grey-dark",
                            size: "18px"
                          }))
                        : _createCommentVNode("", true)
                  ]),
                  option: _withCtx(({ itemProps, opt }) => [
                    _createVNode(_component_q_item, _mergeProps(itemProps, { to: opt }), {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(opt.meta.title), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1040, ["to"])
                  ]),
                  _: 2
                }, [
                  (__props.modelValue.length && !__props.isLoading)
                    ? {
                        name: "no-option",
                        fn: _withCtx(() => [
                          _createVNode(_component_q_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _hoisted_3
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ])
                      }
                    : undefined
                ]), 1040, ["modelValue", "options", "loading"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})